export default class NotImplementedError extends Error {
    constructor(message) {
        super(message);
        this.name = 'NotImplementedError';
    }
}



// WEBPACK FOOTER //
// ./src/services/errors/NotImplementedError.js